import { IconButton, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import Input from './input'
import Clear from '@material-ui/icons/Clear'
import { Button } from '.'

export function CustomInputWithButton({
    value,
    onChange,
    label,
    isError,
    errorText,
    btnLabel,
    handleCancelClick,
    handleBtnClick
}) {
    const classes = useStyles()
    return (
        <>
            <Typography
                style={{
                    maxWidth: '40vw',
                    flex: 1
                }}
            >
                <Input
                    errorInsteadOfLabel={true}
                    label={label}
                    size="small"
                    value={value}
                    setValue={onChange}
                    type="text"
                    isError={isError}
                    errorText={errorText}
                    InputProps={{
                        style: {
                            paddingRight: 2
                        }
                    }}
                    endIcon={() => (
                        <IconButton size="small" onClick={handleCancelClick}>
                            <Clear />
                        </IconButton>
                    )}
                />
            </Typography>
            <Button
                style={{
                    marginBottom: 6,
                    height: 40
                }}
                onClick={handleBtnClick}
            >
                {btnLabel}
            </Button>
        </>
    )
}

export const useStyles = makeStyles(theme => {
    return {
        searchClearIcon: {
            padding: 0,
            position: 'absolute',
            right: 3
        }
    }
})
